import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { Subscription } from 'rxjs';

import { ColorSchemeService } from '../color-scheme.service';
import { KarveTabviewComponent } from '../shared/karve-tabview/karve-tabview.component';

@Component({
    selector: 'app-jobs-page',
    standalone: true,
    imports: [
        BreadcrumbModule,
        KarveTabviewComponent,
        RouterOutlet,
    ],
    templateUrl: './jobs-page.component.html',
    styleUrls: ['./jobs-page.component.scss'],
})
export class JobsPageComponent implements OnInit, OnDestroy {

    home: MenuItem = { icon: 'pi pi-home', routerLink: '/home' };

    breadcrumb: MenuItem[] = [
        { label: 'Jobs' },
    ];

    tabs = [
        { name: 'Recently Created', slug: 'recent' },
        { name: 'Open', slug: 'open' },
        { name: 'Closed', slug: 'closed' },
        { name: 'Open Leads', slug: 'open-leads' },
        { name: 'Open Estimates', slug: 'open-estimates' },
        { name: 'Open Bookings', slug: 'open-bookings' },
        { name: 'Open Invoices', slug: 'open-invoices' },
        { name: 'Pending', slug: 'pending' },
    ];

    private routeSub: Subscription | undefined;

    constructor(
        public colorScheme: ColorSchemeService,
        private route: ActivatedRoute,
    ) { }

    ngOnInit(): void {
        this.routeSub = this.route.firstChild?.url.subscribe((segments) => {
            const slug = segments[0]?.path;
            const tab = this.tabs.find((t) => t.slug === slug);
            this.breadcrumb = [
                { label: 'Jobs' },
                ...(tab ? [{ label: tab.name }] : []),
            ];
        });
    }

    ngOnDestroy(): void {
        this.routeSub?.unsubscribe();
    }
}